import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('user.shared-accounts.request-center', {
        url: '/request-center',
        component: 'requestCenterUser',
        redirectTo: 'user.shared-accounts.request-center.create',
        resolve: {},
    })
}




// WEBPACK FOOTER //
// ./src/portal/states/user/request-center/request-center-user.state.js